import axios, {AxiosResponse} from 'axios'
import {SpreadsheetColumnMapping, SpreadsheetTaskImport, SpreadsheetTaskImportResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const BASE_URL = `${API_URL}/api/spreadsheet-task-imports`

export const createSpreadsheetTaskImport = (
  projectId: number,
  file: File
): Promise<SpreadsheetTaskImportResponse> => {
  const formData = new FormData()
  formData.append('file', file)

  return axios
    .post(`${BASE_URL}/projects/${projectId}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
    .then((response: AxiosResponse<SpreadsheetTaskImportResponse>) => response.data)
}

export const getSpreadsheetTaskImport = (importId: number): Promise<SpreadsheetTaskImport> => {
  return axios
    .get(`${BASE_URL}/${importId}`)
    .then((response: AxiosResponse<{import: SpreadsheetTaskImport}>) => response.data.import)
}

export const confirmSpreadsheetTaskImport = (
  importId: number,
  mapping: SpreadsheetColumnMapping[]
): Promise<SpreadsheetTaskImportResponse> => {
  return axios
    .post(`${BASE_URL}/${importId}/confirm`, {mapping})
    .then((response: AxiosResponse<SpreadsheetTaskImportResponse>) => response.data)
}
